import { InjectionToken } from '@angular/core';

// tslint:disable-next-line:variable-name
export const AppStorage: InjectionToken<Storage> = new InjectionToken<Storage>('AppStorage');
